import UnderConstruction from './UnderConstruction'
export default UnderConstruction
